import React, { Component } from 'react';
import Header1 from '../header/header'
import WebDev from '../webdev/webdev'
import androiddev from '../androiddev/androidDev'
import AndroidDev from '../androiddev/androidDev';
import ProgressDiv from '../progressdiv/progressdiv';
import About from '../about/about';
import Contact from '../contact/contact';
import Testimonial from '../testimonial/testimonial';
import Footer from '../footer/footer';








class Main extends Component {
    render() {

        return (
            <div>
                <Header1 />

                <WebDev />
                <AndroidDev /> 
                <About />
                <ProgressDiv /> 
                <Testimonial />
                <Contact />
                <Footer/>
            </div>
                );
            }
        }
        
        export default Main;



// WEBPACK FOOTER //
// ./src/containers/main/main.js